// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"215":"54e771da81f1eea2","918":"eb542634ba9f62b5"}[chunkId] + ".js";
};